<template>
  <div class="global-header">
    <!--租户到期通知-->
    <div v-if="tipVisible" class="expire-tip">
     <span class="expire-text" style="line-height: 22px">
       <marquee>
       <a-icon type="exclamation-circle" theme="filled" style="color: #faad14;margin-right: 4px;font-size: 14px;"/>
       {{ expireText }}
       </marquee>
       </span>
      <a-button type="link" style="float: right;height: 22px;color: #faad14;font-size: 12px;" @click="closeTip">
        <a-icon type="close" />
        {{ $t('close')}}
      </a-button>
    </div>
    <a-layout-header :class="tipVisible? 'mgt-24':''" style="padding: 0;height:54px;line-height:54px;">
    <a-row>
        <a-col span="19">
          <div style="display:flex;justify-content: flex-start;">
            <logo />
            <app-menu />
          </div>
        </a-col>
        <a-col span="5" style="display: flex; justify-content: flex-end; align-items: center">
          <user-menu @openEdition="openEdition()" />
          <lang-select />
        </a-col>
      </a-row>
    </a-layout-header>
    <a-modal :title="$t('global_header_update_version')" :visible="editionVisible" :closable="false" :width="600">
      <div class="edition-title">
        <div class="edition-title-name">{{ $t('global_header_current_release_time') }}：</div>
        <div>{{ editionItem.publishDate }}</div>
      </div>
      <div class="edition-title">
        <div class="edition-title-name">{{ $t('global_header_current_version') }}：</div>
        <div>{{ editionItem.version }}</div>
      </div>
      <div class="edition-box" v-html="editionItem.content"></div>
      <template slot="footer">
        <a-button key="submit" type="primary" @click="closeShow">
          {{ $t('ok') }}
        </a-button>
      </template>
    </a-modal>
    <a-modal :title="$t('global_header_history_version')" :visible="hisEditionVisible" :closable="false" :width="600">
      <div class="edition-title">
        <div class="edition-title-name">{{ $t('global_header_current_version') }}：</div>
        <div>{{ historyVersion }}</div>
      </div>
      <div class="history-edition-box">
        <template v-for="(item, index) in historyItem">
          <div class="history-edition-box-item" :key="index">
            <div class="history-edition-box-item-title">{{ item.version }} 版本更新</div>
            <div class="history-edition-box-item-time">更新时间：{{ item.publishDate }}</div>
            <div v-html="item.content"></div>
          </div>
        </template>
      </div>
      <template slot="footer">
        <a-button key="submit" type="primary" @click="closehisShow">
          {{ $t('ok') }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import LangSelect from './components/LangSelect'
import UserMenu from './components/UserMenu'
import Logo from './components/Logo'
import AppMenu from './components/AppMenu'
import { getUserInfo } from '@/utils/auth'
import { setLocalStorage, getLocalStorage } from '@/utils/storage'
import dayjs from 'dayjs'
import { editionDetail, editionHistory, queryRole } from '@/api/api'
import { MasterlinkTenantServiceProxy } from '@/service-proxies/app-v2/system.service-proxies.ts'
const mtsp = new MasterlinkTenantServiceProxy()

export default {
  name: 'GlobalHeader',
  components: {
    LangSelect,
    UserMenu,
    Logo,
    AppMenu
  },
  data() {
    return {
      editionVisible: false,
      hisEditionVisible: false,
      historyVersion: '',
      historyItem: [],
      editionItem: {},
      tipVisible: false,
      tenantId: getUserInfo().tenant_id
    }
  },
  computed: {
    expireText () {
      let date = this.info.expireTime ? dayjs(this.info.expireTime).format('YYYY-MM-DD HH:mm:ss') : ''
      return this.$t('page_personal_expires_tip').replace('{0}', date)
    }
  },
  created() {
    this.showEdition()
    console.log(2222, this.tenantId)
    if (this.tenantId) {
      this.getTenantInfo()
    }
  },
  methods: {
    async getTenantInfo () {
      let res = await queryRole(this.tenantId)
      this.info = res.data.data
      let days = this.getExpireTime()
      if (this.info.expireTime && !(days > 30) && !getLocalStorage('hiddenExpireTip')) {
        this.tipVisible = true
      }
    },
    // 租户过期剩余天数
    getExpireTime () {
      let cur = new Date().getTime()
      let later = new Date(this.info.expireTime).getTime()
      let days = (later - cur) / (1000 * 60 * 60 * 24)
      return Math.floor(days) // 毫秒=>日
    },
    closeTip () {
      this.tipVisible = false
      setLocalStorage('hiddenExpireTip', 'true')
    },
    showEdition() {
      editionDetail().then((res) => {
        const valData = res.data.data
        if (valData && valData.firstReview) {
          this.editionItem = valData
          this.editionVisible = true
        }
      })
    },
    openEdition() {
      editionHistory().then((res) => {
        const valData = res.data.data
        if (valData && valData.length) {
          this.historyVersion = valData[0].version
          this.historyItem = valData
          this.hisEditionVisible = true
        }
      })
    },
    closehisShow() {
      this.hisEditionVisible = false
    },
    closeShow() {
      this.editionVisible = false
    }
  }
}
</script>

<style lang="less">
.global-header {
  .expire-tip {
    height: 24px;
    background-color: #fffbe6;
    border: solid 1px #ffe58f;
    width: 100%;
    position: fixed;
    z-index: 1;
    font-size: 12px;
    padding-left: 14px;
    display: flex;

    .expire-text {
      line-height: 22px;
      display: flex;
      width: calc(100% - 76px - 16px);
    }
  }

  .action {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0 12px;
    // display: inline-block;
    transition: all 0.3s;
    height: 54px;
    line-height: 54px;
    color: rgba(0, 0, 0, 0.65);
    &:hover {
      background: rgba(255, 255, 255, 0.15);
    }
    .anticon {
      color: #fff;
      font-size: 20px;
    }
    .avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
    }
    a {
      color: #fff;
    }
  }
}
.edition-box {
  border: 1px solid #d8d8d8;
  padding: 12px 8px;
  height: 400px;
  overflow: auto;
}
.edition-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #3a7fbc;
  padding-bottom: 20px;
  font-weight: 600;
}
.history-edition-box {
  border: 1px solid #d8d8d8;
  padding: 12px 8px;
  height: 400px;
  overflow: auto;
  &-item {
    padding-bottom: 20px;
    &-title {
      font-size: 17px;
      font-weight: bold;
      font-stretch: normal;
      line-height: 22px;
      letter-spacing: 0px;
      color: #4a90e2;
    }
    &-time {
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      line-height: 22px;
      letter-spacing: 0px;
      color: rgba(0, 0, 0, 0.85);
      padding-bottom: 8px;
    }
  }
}
  .mgt-24{
    margin-top: 24px;
  }
</style>
